import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { setCanceledBonus } from "redux/user/slice";
import { userApi } from "redux/user/api";
import BonusList from "components/organisms/BonusList";
import { useGetGamesByIdsForFs } from "queries/useGetGamesByIdsForFs";
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";
import {
  BonusFreeSpinsMappedType,
  BonusListType,
  BonusNominalMappedType,
  BonusTriggerMappedType,
  TriggerFreeSpinMappedType,
} from "types/Bonus";

const BonusListContainer = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { refetch: bonusRefetch } = userApi.useBonusesQuery("", {
    skip: !isAuthenticated,
  });
  const { refetch: bonusNominalRefetch } = userApi.useBonusNominalQuery("", {
    skip: !isAuthenticated,
  });
  const { refetch: spinRefetch } = userApi.useFreeSpinsQuery("", {
    skip: !isAuthenticated,
  });
  const { refetch: triggersRefetch } = userApi.useAvailableTriggersQuery("", {
    skip: !isAuthenticated,
  });

  const {
    bonuses,
    bonusNominal,
    triggerCompaings,
    freeSpins,
    firstDeposit,
    currency,
  } = useSelector(userSelectors.all);
  // const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const namesGames = [
    ...new Set(
      bonusNominal
        ?.filter((nominal) => "freeSpinsGame" in nominal)
        .map((nominal) => (nominal as BonusFreeSpinsMappedType).freeSpinsGame),
    ),
  ];
  const data = useGetGamesByIdsForFs(namesGames);

  const { games } = data;
  const freeSpinsMapped = freeSpins.map((freeSpin) => {
    return {
      ...freeSpin,
      gameUrlAlias: freeSpin?.game?.urlAlias
        ? freeSpin?.game.urlAlias
        : "Unknown",
    };
  });

  const bonusNominalWithGames: Array<
    BonusNominalMappedType | BonusFreeSpinsMappedType
  > = bonusNominal.map((nominal) => {
    if ("freeSpinsGame" in nominal) {
      const game = games?.find((gameType) => {
        return gameType?.uuid === nominal.freeSpinsGame;
      });

      return {
        ...nominal,
        nameGameFreeSpin: nominal?.gameName ? nominal.gameName : "Unknown",
        gameUrlAlias: game?.urlAlias ? game.urlAlias : "Unknown",
      };
    }

    return nominal;
  });

  const bonusTriggerCampaingsWithGames: Array<
    BonusTriggerMappedType | TriggerFreeSpinMappedType
  > = triggerCompaings.map((trigger) => {
    if ("freeSpinsGame" in trigger) {
      const game = games?.find((gameType) => {
        return gameType?.uuid === trigger.freeSpinsGame;
      });

      return {
        ...trigger,
        nameGameFreeSpin: game?.name ? game.name : "Unknown",
        gameUrlAlias: game?.urlAlias ? game.urlAlias : "Unknown",
      };
    }

    return trigger;
  });

  const list = useMemo<BonusListType[]>(
    () => [
      ...bonuses,
      ...bonusTriggerCampaingsWithGames,
      ...freeSpinsMapped,
      ...bonusNominalWithGames,
    ],
    [
      bonuses,
      freeSpinsMapped,
      bonusNominalWithGames,
      bonusTriggerCampaingsWithGames,
    ],
  );

  useEffect(() => {
    if (isAuthenticated) {
      bonusRefetch();
      bonusNominalRefetch();
      spinRefetch();
      triggersRefetch();
    }
  }, [
    isAuthenticated,
    bonusRefetch,
    spinRefetch,
    triggersRefetch,
    bonusNominalRefetch,
  ]);

  const selectCanceledBonus = (bonus: BonusListType) => {
    dispatch(setCanceledBonus(bonus));
  };

  return (
    <BonusList
      hasFirstDeposit={firstDeposit}
      list={list}
      setCanceledBonus={selectCanceledBonus}
      currency={currency}
    />
  );
};

export default BonusListContainer;
